// @flow

export default {
  auth: {
    root: '/auth',
    signUp: {
      root: '/auth/register',
      successful: '/auth/register/successful',
    },
    signIn: {
      root: '/auth/signin',
    },
    recovery: {
      root: '/auth/recovery_password',
    },
    reset: {
      root: '/auth/reset_password',
    },
    email: {
      root: '/auth/email',
    },
    passwordChangeSuccess: {
      root: '/auth/password_change_success',
    },
    confirmEmail: {
      root: '/auth/confirm_email',
    },
  },
  app: {
    root: '/',
    combinationTable: {
      root: '/cards',
    },
    resultsTable: {
      root: '/results',
    },
    trainingGame: {
      root: '/training',
    },
    postflop: {
      root: '/postflop',
    },
    postflopResults: {
      root: '/postflop-results',
    },
    profile: {
      root: '/profile',
    },
    PreflopFAQ: {
      root: '/preflop-faq',
    },
    trainingFaq: {
      root: '/training-faq',
    },
    FAQ: {
      root: '/faq',
    },
    resultsFAQ: {
      root: '/resultsFAQ',
    },
    articles: {
      root: '/articles',
      tips: {
        root: '/articles/tips',
      },
      suit: {
        root: '/articles/suit',
      },
      threeArticle: {
        root: '/articles/threearticle',
      },
      goodbadsuitplo5: {
        root: '/articles/goodbadsuitplo5',
      },
      singledoublesuitplo5: {
        root: '/articles/singledoublesuitplo5',
      },
    },
    certainArticle: {
      root: '/articles/:index',
      toArticles: (id: string) => `/articles/${id}`,
    },
    partners: {
      root: '/partners',
    },
    termAndConditions: {
      root: '/term_and_conditions',
    },
    privacy: {
      root: '/privacy',
    },
    payments: {
      root: '/payments/:type',
      toPayments: (type: string) => `/payments/${type}`,
    },
  },
};
